/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bg-img[_ngcontent-%COMP%]{background-image:url(/assets/img/bcg.png);padding-top:96px}"];
export { styles as styles };
